import React, {createRef} from 'react';

type Props = {
  width?: number;
  height?: number;
  className?: string;
  margin?: {left?: number; right?: number; top?: number; bottom?: number};
  draw: (svg: SVGSVGElement) => void;
  drawIntervalMs?: number;
};

export default class StaticSvgDraw extends React.Component<Props> {
  ref = createRef<SVGSVGElement>();

  componentDidMount() {
    this.update();
    if (this.props.drawIntervalMs) {
      setInterval(() => this.update(), this.props.drawIntervalMs);
    }
  }

  componentDidUpdate() {
    this.update();
  }

  render() {
    const {width, height, className, margin} = this.props;
    const totalWidth = (width ?? 0) + (margin?.left ?? 0) + (margin?.right ?? 0);
    const totalHeight = (height ?? 0) + (margin?.top ?? 0) + (margin?.bottom ?? 0);
    const x0 = -(margin?.top ?? 0);
    const y0 = -(margin?.bottom ?? 0);
    return (
      <svg
        ref={this.ref}
        width={totalWidth || undefined}
        height={totalHeight || undefined}
        className={className}
        viewBox={`${x0} ${y0} ${totalWidth} ${totalHeight}`}
      />
    );
  }

  update() {
    if (this.ref.current) {
      this.props.draw(this.ref.current);
    }
  }
}
